import { createContext, useEffect, useState, useContext } from 'react'
import { getProfileApi, loginApi, logoutApi } from '../api/api'

export const AuthContext = createContext(null)

export default function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    // Load cached user if available
    const stored = localStorage.getItem('user')
    return stored ? JSON.parse(stored) : null
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) {
      setLoading(false);
      return
    }
    // if user already cached, skip API call
    if (user) {
      setLoading(false)
      return
    }
    getProfileApi()
      .then((res) => {
        const profile = res.data?.data || res.data;
        setUser(profile);
        localStorage.setItem('user', JSON.stringify(profile));
      })
      .catch(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      })
      .finally(() => setLoading(false))
  }, [])

  const login = async (tallyUserId, password) => {
    try {
      console.log(tallyUserId, password);
      // Support both new and old field names for backward compatibility
      const payload = tallyUserId ? { tallyUserId, password } : { tallyUserId: tallyUserId, password };
      const res = await loginApi(payload)
      const userData = res?.data?.data || res?.data || {}
      const { authToken, ...userPayload } = userData
      if (authToken) localStorage.setItem('token', authToken)
      setUser(Object.keys(userPayload).length ? userPayload : null);
    } catch(err) {
      // setUser(Object.keys(userPayload).length ? userPayload : null)
      throw err;
    }
  }

  const logout = async () => {
    try { await logoutApi() } catch {}
    localStorage.removeItem('token');
    localStorage.removeItem('user')
    setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

// ✅ FIX: make sure useContext is imported
export const useAuth = () => useContext(AuthContext)
